import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="custom-footer">
      {/* Pre-footer call-to-action band */}
      <div className="footer-cta-band">
        <div className="footer-cta-inner">
          <div className="footer-cta-copy">
            <h3>Ready for a spotless ride?</h3>
            <p>Book your detail online in under a minute.</p>
          </div>
          <Link to="/booking" className="footer-cta">Book an Appointment</Link>
        </div>
      </div>

      <div className="footer-container">
        {/* Brand */}
        <div className="footer-column footer-brand">
          <h2 className="footer-logo-text">J &amp; G DETAILING</h2>
          <p className="footer-tagline">Premium auto detailing in the Twin Cities — showroom results, every time.</p>
          <div className="footer-social">
            <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="2" y="2" width="20" height="20" rx="5" /><circle cx="12" cy="12" r="4" /><circle cx="17.5" cy="6.5" r="1.2" fill="currentColor" stroke="none" />
              </svg>
            </a>
            <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
              </svg>
            </a>
          </div>
        </div>

        {/* Explore */}
        <div className="footer-column">
          <h4>Explore</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/booking">Book Now</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        {/* Contact */}
        <div className="footer-column">
          <h4>Get in touch</h4>
          <a className="footer-link" href="mailto:contact@jgdetailingllc.com">contact@jgdetailingllc.com</a>
          <a className="footer-link" href="tel:+17637109136">Office · (763) 710-9136</a>
          <a className="footer-link" href="tel:+19522159310">John · (952) 215-9310</a>
          <a className="footer-link" href="tel:+16122299151">Glenn · (612) 229-9151</a>
        </div>

        {/* Visit */}
        <div className="footer-column">
          <h4>Visit us</h4>
          <p className="footer-address">
            701 Decatur Ave N, Suite 204<br />
            Golden Valley, MN 55427
          </p>
          <p className="footer-hours"><strong>Mon – Fri</strong><br />By appointment · Closed weekends</p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {year} J &amp; G Detailing LLC. All rights reserved.</p>
        <div className="footer-bottom-links">
          <Link to="/terms">Terms</Link>
          <span aria-hidden="true">·</span>
          <Link to="/privacy">Privacy</Link>
          <span aria-hidden="true">·</span>
          <span>Designed by <a href="https://zyrixcode.com" target="_blank" rel="noopener noreferrer">Zyrix Technologies</a></span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
